/* Memorigin landing pages: the "On this page" menu follows the reader. */
(function () {
  function init(root) {
    var nav = root.querySelector('.lp-snav__in');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var links = [].slice.call(nav.querySelectorAll('a[href^="#lp-s"]'));
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = root.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var secs = [].slice.call(root.querySelectorAll('section.lp-sec'));
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var id = '#' + e.target.id, on = null;
        links.forEach(function (a) {
          var hit = a.getAttribute('href') === id && !a.classList.contains('grp');
          a.classList.toggle('on', hit);
          if (hit) on = a;
        });
        if (on) nav.scrollTo({ left: on.offsetLeft - 60, behavior: 'smooth' });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    secs.forEach(function (s) { io.observe(s); });
    window.addEventListener('scroll', function () {
      if (secs[0] && secs[0].getBoundingClientRect().top > window.innerHeight * 0.5) {
        links.forEach(function (a) { a.classList.remove('on'); });
        nav.scrollLeft = 0;
      }
    }, { passive: true });
  }
  function run() { document.querySelectorAll('.mg-lp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
